export default __webpack_public_path__ + "static/media/bear.2c363082.glb";